import copyDictTrackerToProps from "./copy-dict-tracker-to-props.js";

class DictTrackerObjGen {
    constructor(wrapCtx, evtCtx, dictTracker) {
        this._data = wrapCtx.getWrapper({});
        this._events = evtCtx.getEvents(this._data);
        this._dictTracker = dictTracker;
    }

    get data() {
        return this._data;
    }

    get events() {
        return this._events;
    }

    update() {
        copyDictTrackerToProps(this._data, this._dictTracker);
    }
}

export default DictTrackerObjGen;
